import {stateData, reduxState} from '../../values';

export const getServices = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_service,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateServices = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_service,
            payload:    data,
        })
    }
}